import React from "react";
import { Modal, Table, Container } from "react-bootstrap";

import "../../generic/css/ResponsiveForms.css";
import "../css/SiteCircuitManagement.css";
import "../css/InfoModal.css";

const SiteDataModal = ({ siteData, show, setShow }) => {
  const closeModal = () => {
    setShow(false);
  };

  return (
    <>
      <Container>
        <Modal
          show={show}
          onHide={closeModal}
          dialogClassName="info-modal"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header
            style={{ border: "none", flexShrink: 0 }}
            className="ms-2 me-2"
            closeButton
          >
            <Modal.Title>Site: {siteData.siteName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="info-modal-table-scroll">
              <Table striped bordered hover>
                <tbody>
                  <tr>
                    <td className="fw-bold text-start">Site ID</td>
                    <td className="text-start">{siteData.siteId}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Name</td>
                    <td className="text-start">{siteData.siteName}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Address One</td>
                    <td className="text-start">{siteData.addressOne}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Address Two</td>
                    <td className="text-start">{siteData.addressTwo}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">City</td>
                    <td className="text-start">{siteData.city}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Postal Code</td>
                    <td className="text-start">{siteData.postalCode}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">State</td>
                    <td className="text-start">{siteData.state}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">State Abbreviation</td>
                    <td className="text-start">{siteData.stateAbbr}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Country</td>
                    <td className="text-start">{siteData.country}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Country Code</td>
                    <td className="text-start">{siteData.countryCode}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Business Region</td>
                    <td className="text-start">
                      {siteData.businessRegionName}
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Geo Region</td>
                    <td className="text-start">{siteData.geoRegion}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Latitude</td>
                    <td className="text-start">{siteData.lat}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Longitude</td>
                    <td className="text-start">{siteData.lon}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Ownership</td>
                    <td className="text-start">{siteData.ownership}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Status</td>
                    <td className="text-start">{siteData.status}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold text-start">Site Type</td>
                    <td className="text-start">{siteData.type}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default SiteDataModal;
